import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GridApi, ColumnApi, GridOptions, ColDef, RowClickedEvent, PaginationChangedEvent, GridReadyEvent, Column, FilterChangedEvent, FilterModifiedEvent, FilterOpenedEvent } from 'ag-grid-community';import Swal from 'sweetalert2'
import { IMerchantData } from '../service-provider-management.component';
import { BtnCellRenderer } from 'src/app/common/button-cell-renderer.component';
import { environment } from 'src/environments/environment';
import { MerchantService } from '../../merchants/merchant-master/merchant.service';
import { Location } from '@angular/common';
import * as moment from 'moment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService } from 'src/app/_services/alert.service';
import { AmountInputCellRenderer } from 'src/app/common/amount-input-cell-renderer.component';
import { SelectCellRenderer } from 'src/app/common/select-cell-renderer.component';
import { InputCellRenderer } from 'src/app/common/input-cell-renderer.component';
import { DatepickerCellRenderer } from 'src/app/common/datepicker-cell-renderer.component';
import { ProductService } from '../../product-management/product-service';
import { ProductSubCategoryService } from '../../product-subcategory-management/product-subcategory-service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { ServiceProviderService } from '../service-provider-service';

export interface CustomerListFilter {
  "columns"?: any;
  "fullname"?: string,
  "mobile"?: string,
  "startDate"?: string,
  "endDate"?: string,
  "pageRecords"?: number,
  "pageNumber"?: number,
  "emailId"?: string,
  "Status"?: string,
  "KycStatus"?: string

}

export class ProductTable{
  "id": number
  "productIcon":any
  "productName" : string
  "categoryName" : string
  "subCategoryName": string
}

export class SlabTableFormat {
  "id": number;
  "fromAmount": number;
  "toAmount": number;
  "commissionType": String;
  "commission": number;
  "minCommission": number;
  "maxCommission": number;
  "effectiveUpdatedDate": String;
  "productId" : number;
  "updatedBy": String;
  "updatedOn": String;
  "approvedBy": String;
  "aprrovedOn": String;
  "isAmountDisabled": Boolean;
  "showEditButton": Boolean;
  "isDatepickerDisabled": Boolean;
  "isSelectDisabled": Boolean;
}

const { API_URL, defaultPageSizeArr, defaultPageSize,defaultPhoneCode} = environment;

@Component({
  selector: 'app-service-provider-add',
  templateUrl: './service-provider-add.component.html',
  styleUrls: ['./service-provider-add.component.scss']
})
export class ServiceProviderAddComponent implements OnInit {

  addServiceProviderForm: FormGroup;
  submitted: boolean = false;
  addCommissionForm: FormGroup;
  submittedCommission: boolean = false;
  activeTab: any = "service";
  globalSearch: string = '';
  public rowData!: IMerchantData[];
  private filterObj: any = {};
  private gridApi!: GridApi;
  collectiondata: number = 0;
  collectionSize: number = 0;
  private gridColumnApi!: ColumnApi;
  currentPage: number = 1;
  public pageNumber: number
  ellipses: boolean = true;
  maxSize: number;
  productTableClass : ProductTable;
  productTableList :any [];
  productIds : any [];

  private columnApi: ColumnApi;
  private gridApiDirect: GridApi;
  private gridApiSlab: GridApi;
  slabTypeData: SlabTableFormat;
  public directData: any[];
  public slabData: any[];
  public finalCommissionData : any[];
  showDataTable : boolean = false;
  countryDropDown : any[];
  categoryDropDown : any[];
  subCategoryDropDown : any[];
  productDropDown : any[];
  selectedProduct : any;


  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 160,
    resizable: true,
    sortable: true,
    filter: false,
    autoHeight: true
  };

  public columnDefs: ColDef[] = [
    {
      field: 'commissionType', headerName: 'Commission Type', cellRenderer: SelectCellRenderer, cellEditorParams: {
        options: [
          { value: 'FLAT', label: 'FLAT' },
          { value: 'PERCENTAGE', label: 'PERCENTAGE' },
        ]
      }
    },
    { field: 'commission', headerName: 'Commission', cellRenderer: InputCellRenderer },
    { field: 'minCommission', headerName: 'Minimum Commission', cellRenderer: InputCellRenderer },
    { field: 'maxCommission', headerName: 'Maximum Commission', cellRenderer: InputCellRenderer },
    {field: 'fromAmount', headerName: 'From Amount', editable:false, cellRenderer: AmountInputCellRenderer},
    {
      field: 'toAmount', headerName: 'To Amount', resizable: true, cellRenderer: AmountInputCellRenderer, onCellValueChanged: (params: any) => {
        const toAmountValue = parseFloat(params.newValue);
        const maxBalanceValue = parseFloat(this.addServiceProviderForm.value.maxBalance);
        if (!isNaN(toAmountValue) && toAmountValue < maxBalanceValue) {
          const nextRowVal = this.gridApiSlab.getDisplayedRowAtIndex(params.node.rowIndex + 1)!.data;
          const rowNode = this.gridApiSlab.getRowNode((params.node.rowIndex + 1).toString());
          if (rowNode) {
            const nextFromAmount = parseFloat((toAmountValue + 0.01).toFixed(2));
            this.finalCommissionData[params.node.rowIndex + 1].fromAmount = nextFromAmount;
            const newData = { ...rowNode.data, fromAmount: nextFromAmount };
            rowNode.setData(newData);
            this.gridApiSlab.refreshCells({ rowNodes: [rowNode], force: true });
          }
        }
      }
    },
    { field: 'id', headerName: 'ID', hide: true },
    {
      field: 'effectiveUpdatedDate', headerName: 'Effective Update Date', cellRenderer: DatepickerCellRenderer, onCellValueChanged: (params: any) => {
        this.finalCommissionData.map((_: any, i: number) => {
          _.effectiveUpdatedDate = moment(params.newValue, ['YYYY-MM-DD HH:mm']).format("MM-DD-YYYY HH:mm");
        })
        this.gridApiSlab.setRowData(this.finalCommissionData);
      }
    },

  ];

  columnDefsCopy: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  tableSelectedColumn: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];

  constructor(private router: Router,private merchantService : MerchantService,private formBuilder : FormBuilder,private alertService : AlertService, private productService : ProductService, private subCategoryService : ProductSubCategoryService,private sanitizer: DomSanitizer,private providerService : ServiceProviderService) { }

  ngOnInit() {
    this.activeTab ="service";
    this.productTableList = [];
    this.productIds = [];
    this.directData = [];
    // this.slabData = [];
    
    this.addServiceProviderForm = this.formBuilder.group({
      serviceProviderName : ['',Validators.required,],
      serviceProviderDesc : ['',Validators.required],
      serviceProviderCode : ['',Validators.required],
      country : [null,Validators.required],
      contactCountryCode : [defaultPhoneCode,Validators.required],
      contactNumber : ['',[Validators.required,Validators.pattern('[123456789][0-9]{8}')]],
      emailId : ['',[Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,10}$')]],
       category : [null,Validators.required],
      subCategory : [null,Validators.required],
      maxBalance : ['',Validators.required],
      product : [null,Validators.required]
    })
    this.addServiceProviderForm.get("contactCountryCode")?.valueChanges.subscribe(
      (data: any) => {
        console.log(data);
        let newPattern = data === defaultPhoneCode ? "[123456789][0-9]{8}" : "[123456789][0-9]{9}"
        const inputFieldControl = this.addServiceProviderForm.get('contactNumber');
        inputFieldControl?.setValidators([Validators.pattern(newPattern)]);
        inputFieldControl?.updateValueAndValidity();
      }
    )

    this.addCommissionForm = this.formBuilder.group({
      product: [null, Validators.required],
    })

    this.productService.getCountryDropdown().subscribe((response:any)=>{
      console.log(response);
      this.countryDropDown = response.response.data;
    })

    this.subCategoryService.getCategoryDropdown().subscribe((response: any) => {
      this.categoryDropDown = response.response.data;
      this.subCategoryDropDown = [];
      this.productDropDown = [];
    })
  }


  get addServiceProviderFormControl() {
    return this.addServiceProviderForm.controls;
  }

  cancelButton(){
    this.router.navigateByUrl('/serviceProviderList')
  }

  categoryChange(category: any) {
    console.log(category.id);
    this.productService.getSubCategoryDropdownById(category.id).subscribe((response: any) => {
      this.subCategoryDropDown = response.response.data;
    });
    this.addServiceProviderForm.controls.subCategory.setValue(null)
    this.addServiceProviderForm.controls.product.setValue(null)

  }

  subCategoryChange(subCategory : any){
    console.log(subCategory.name);
    this.productService.getProductList("","",subCategory.name,"","",50,0,"","").subscribe((response: any) => {
      this.productDropDown = response.content;
    });
    this.addServiceProviderForm.controls.product.setValue(null)
  }

  saveServiceProvider(data:any){
    this.submitted = true;
    console.log(data);
    if(this.addServiceProviderForm.valid){
      console.log("Valid");
      if (this.productTableList.length == 0) {
        this.alertService.errorAlertWithMessage("Please add the product");
        return;
      }
      this.activeTab = "commission";
    }else{
      console.log("Not Valid");
    }
  }

  saveCommission(data:any){
    if(this.addCommissionForm.valid){
      console.log("Valid");
      if(this.finalCommissionData.length == 0){
        this.alertService.errorAlertWithMessage("Please set the slab for selected product");
        return;
      }else{
        this.finalCommissionData = JSON.parse(JSON.stringify(this.finalCommissionData));
        this.finalCommissionData.map((_:any)=>{
        delete _.isAmountDisabled;
      })
      console.log(data);
      let requestForm = {
        "name": this.addServiceProviderForm.value.serviceProviderName,
        "code" : this.addServiceProviderForm.value.serviceProviderCode,
        "contact": this.addServiceProviderForm.value.contactCountryCode+" "+this.addServiceProviderForm.value.contactNumber,
        "email": this.addServiceProviderForm.value.emailId,
        "countryId" : this.addServiceProviderForm.value.country,
        "description": this.addServiceProviderForm.value.serviceProviderDesc,
        "productIds": this.productIds,
        "maxBalance" : this.addServiceProviderForm.value.maxBalance,
        "slabs" : this.finalCommissionData,
      };
    this.providerService.saveServiceprovider(requestForm).subscribe((response:any)=>{
      console.log(response);
      if(response.response.status == 200){
        Swal.fire(response.response.message, '', 'success').then((result)=>{
          if (result.isConfirmed) {
            this.router.navigate(['/serviceProviderList']);
          } 
        });
      }else if(response.response.status == 400){
        Swal.fire(response.response.message, '', 'error');
        return;
      }else{
        Swal.fire('Error while saving service provider', '', 'error');
      }
    })
      

      }
    }else{
      console.log("Not Valid");
    }
  }

  OnlyCharacterAllowed(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    console.log(charCode);
    if(charCode == 32){
      return true;
    }else if ((charCode == 96 || charCode < 65 ||charCode > 122) && (charCode < 48 ||charCode > 57)) {
      return false;
    }
    return true;
  }

  onPaste(e: any) {
    e.preventDefault()
  }

  switchTab(tab: string): void {
    this.activeTab = tab;
  }

  onGridReady(params: GridReadyEvent<any>) {
    this.gridApiSlab = params.api
  }


  addProduct(){
  this.submitted =true;
    if(this.addServiceProviderForm.value.category == "" || this.addServiceProviderForm.value.category == null){
      console.log("test");
      return;
    }
    if(this.addServiceProviderForm.value.subCategory == "" || this.addServiceProviderForm.value.subCategory == null){
      console.log("test");
      return;
    }
    if(this.addServiceProviderForm.value.product == "" || this.addServiceProviderForm.value.product == null){
      console.log("test");
      return;
    }
    if(this.addServiceProviderForm.value.maxBalance == "" || this.addServiceProviderForm.value.maxBalance == null){
      this.alertService.errorAlertWithMessage("Enter Maximum Balance");
      return;
    }
    if(parseInt(this.addServiceProviderForm.value.maxBalance) == 0){
      this.alertService.errorAlertWithMessage("Maximum Balance cannot be 0");
      return;
    }
    
    for(let i:number = 0;i<this.productTableList.length;i++){
      if(this.addServiceProviderForm.value.product.name==this.productTableList[i].productName){
        this.alertService.errorAlertWithMessage("Please select different product it is already mapped");
        return;
      }
    }
    this.productTableClass = new ProductTable;
    //call api for getting product by id for (icon,productName,categoryName,subCategoryName)
    this.productService.getProductById(this.addServiceProviderForm.value.product.id).subscribe((response:any)=>{
      this.setProductProfileByApi(response.response.data.icon).subscribe((response:any)=>{
        console.log(response);
        let imageUrl = URL.createObjectURL(response);
        this.productTableClass.productIcon = this.sanitizer.bypassSecurityTrustUrl(imageUrl);
        console.log(this.productTableClass.productIcon);
    });
    })
    
    this.productTableClass.productName = this.addServiceProviderForm.value.product.name;
    this.productTableClass.id = this.addServiceProviderForm.value.product.id;
    this.productTableClass.categoryName = this.addServiceProviderForm.value.category.name;
    this.productTableClass.subCategoryName = this.addServiceProviderForm.value.subCategory.name;
    this.productTableList.push(this.productTableClass);
    this.productTableList = [...this.productTableList];
    this.productIds.push(JSON.stringify(this.addServiceProviderForm.value.product.id));
    console.log(this.productIds);
    console.log(this.productTableList);

 
  }

  productChange(productSelect : any){
    this.selectedProduct = "";
    this.slabData = [];
    this.finalCommissionData = [];
    this.selectedProduct = productSelect;
    console.log(this.selectedProduct);
    this.showDataTable = false;
    if(this.addCommissionForm.valid){
      this.showDataTable = true;
     this.finalCommissionData = [];
    }
  }

  onCellValueChanged(params:any){
    console.log(params);
    if(!params.newValue){
      return;
    }
    if(params.value == "FLAT" || params.value == "PERCENTAGE"){
        this.finalCommissionData[params.rowIndex].commission = 0;
        this.gridApiSlab.setRowData(this.finalCommissionData);
        return;
      }

    if(params.column.colId == "maxCommission"){

      if(parseInt(this.finalCommissionData[params.rowIndex].maxCommission) == 0){
        this.finalCommissionData[params.rowIndex].minCommission = 0;
        this.gridApiSlab.setRowData(this.finalCommissionData);
        return;
      }

      if(parseInt(this.finalCommissionData[params.rowIndex].minCommission) > parseInt(this.finalCommissionData[params.rowIndex].maxCommission)){
        this.finalCommissionData[params.rowIndex].minCommission = 0;
        this.gridApiSlab.setRowData(this.finalCommissionData);
        return;
      }

      if(parseInt(this.finalCommissionData[params.rowIndex].maxCommission) > parseInt(this.finalCommissionData[params.rowIndex].toAmount)){
        this.finalCommissionData[params.rowIndex].maxCommission = 0;
        this.finalCommissionData[params.rowIndex].minCommission = 0;
        this.alertService.toastWarringMessageAlertWithMessage("Maximum Commission cannot be greater than TO AMOUNT");
        this.gridApiSlab.setRowData(this.finalCommissionData);
        return;
      }


    }else if(params.column.colId == "minCommission"){
      if(parseInt(this.finalCommissionData[params.rowIndex].minCommission)<0){
        this.finalCommissionData[params.rowIndex].minCommission = 0;
        this.gridApiSlab.setRowData(this.finalCommissionData);
        return;
      }
      console.log(this.finalCommissionData[params.rowIndex].minCommission);
      console.log(this.finalCommissionData[params.rowIndex].maxCommission);
      if(parseInt(this.finalCommissionData[params.rowIndex].minCommission) > parseInt(this.finalCommissionData[params.rowIndex].maxCommission)){
        this.alertService.toastWarringMessageAlertWithMessage("Minimum Commission cannot be greater than Maximum Commission");
        this.finalCommissionData[params.rowIndex].minCommission = 0;
        this.gridApiSlab.setRowData(this.finalCommissionData);
        return;
      }
    }else if(params.column.colId == "commission"){
      if(this.finalCommissionData[params.rowIndex].commissionType == "PERCENTAGE"){
        if(parseInt(this.finalCommissionData[params.rowIndex].commission) >= 100){
          this.alertService.toastWarringMessageAlertWithMessage("Maximum Commission cannot be greater than 100 Percentage");
          this.finalCommissionData[params.rowIndex].commission = 0;
          this.gridApiSlab.setRowData(this.finalCommissionData);
          return;
        }
      }else if(this.finalCommissionData[params.rowIndex].commissionType == "FLAT"){
        if(parseInt(this.finalCommissionData[params.rowIndex].commission) > parseInt(this.finalCommissionData[params.rowIndex].toAmount)){
          this.alertService.toastWarringMessageAlertWithMessage("Maximum Commission cannot be greater than TO AMOUNT");
          this.finalCommissionData[params.rowIndex].commission = 0;
          this.gridApiSlab.setRowData(this.finalCommissionData);
          return;
        }
      } 
    }
  }

  deleteProduct(cardData : any){
    console.log(cardData);
    this.productTableList.splice(cardData,1);
    this.productTableList = this.productTableList;
    this.productIds.splice(cardData,1);
    this.productIds = this.productIds;
  }

  addRow(){
    for(let i:number = 0;i<this.finalCommissionData.length;i++){
      if(this.finalCommissionData[i].type == "SLAB" || this.finalCommissionData[i].type == "Slab"){
        const newRow = { fromAmount: 1, toAmount: 0, commissionType: "PERCENTAGE", commission: 0,minCommission:0,maxCommission:0,productId: this.selectedProduct.id, effectiveUpdatedDate: moment().format("MM-DD-YYYY HH:mm"), isAmountDisabled: false ,type:"SLAB"};
        this.finalCommissionData = [newRow, ...this.finalCommissionData];
        this.gridApiSlab.setRowData(this.finalCommissionData);
        return;
      }
    }
    const newRow = { fromAmount: 1, toAmount: this.addServiceProviderForm.value.maxBalance, commissionType: "PERCENTAGE", commission: 0,minCommission:0,maxCommission:0,productId: this.selectedProduct.id, effectiveUpdatedDate: moment().format("MM-DD-YYYY HH:mm"), isAmountDisabled: false ,type:"SLAB"};
    this.finalCommissionData = [newRow, ...this.finalCommissionData];
    this.gridApiSlab.setRowData(this.finalCommissionData);
  }

  clearButton(){
    this.slabData = [];
    this.finalCommissionData = [];
    this.gridApiSlab.setRowData(this.finalCommissionData);
  }

  async selectSpecificAmount() {
    let inputSpecificAmount: HTMLInputElement;
    await Swal.fire({
      title: "Please enter the Specific Amount",
      html: '<input type="text" class="swal2-input" id="specificAmount" placeholder="Enter Specific Amount" maxlength="10" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">',
      confirmButtonText: '<span id="confirm-button-text">OK</span>',
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonColor: '#f56d1d',
      cancelButtonColor: '#d33',
      customClass: {
        confirmButton: 'swal2-confirm-custom',
        cancelButton: 'swal2-cancel-custom'
      },
      didOpen:()=>{
        const popup = Swal.getPopup()!
        inputSpecificAmount = popup.querySelector('#specificAmount') as HTMLInputElement
        inputSpecificAmount.onkeyup = (event) => event.key === 'Enter' && Swal.clickConfirm()
      },
      preConfirm:()=>{
        if(inputSpecificAmount.value != ""){
          console.log(inputSpecificAmount.value);
          if(parseInt(inputSpecificAmount.value) >= parseInt(this.addServiceProviderForm.value.maxBalance)){
            this.alertService.toastWarringMessageAlertWithMessage("Specific amount cannot be greater than max balance");
            return;
          }
          const newRow = { fromAmount: Number(inputSpecificAmount.value), isAmountDisabled: true, toAmount: Number(inputSpecificAmount.value), commission: 0,minCommission:0,productId: this.selectedProduct.id, maxCommission:0,  commissionType: "PERCENTAGE", serviceCharge: 0, effectiveUpdatedDate: moment().format("MM-DD-YYYY HH:mm"),type: "SPECIFIC AMOUNT"};
            for(let i:number = 0;i<this.finalCommissionData.length;i++){
              if(this.finalCommissionData[i].fromAmount == this.finalCommissionData[i].toAmount){
                if(this.finalCommissionData[i].fromAmount == inputSpecificAmount.value){
                  this.alertService.toastWarringMessageAlertWithMessage("Please enter different specific amount");
                  return;
                }
              }
            }
            this.finalCommissionData = [...this.finalCommissionData, newRow];
            this.gridApiSlab.setRowData(this.finalCommissionData);
        }else{
          this.alertService.toastWarringMessageAlertWithMessage("Please enter specific amount");
          return;
        }
      },
    });
  }

  setProductProfileByApi(profile: any) : Observable<any> {
    console.log("Choose File "+profile);
    let url = "product/"+profile;
    return this.productService.getProfileImage(url)
  }

}
